import URL from 'url-parse';
import axios from 'axios';
import Axios from 'axios/lib/core/Axios';
import { isServerRendering } from '@kso/util';
import isPlainObject from 'lodash/isPlainObject';

function relativeProtocol(uri) {
  if (uri && /^(\/\/)(.+)$/.test(uri)) {
    var protocol = isServerRendering() && 'https' || window.location.protocol;
    uri = "".concat(protocol).concat(uri);
  }

  return uri;
}
/**
 * @params ctx {object} 需要注入的实例
 * @params options {object} 注入的函数
 * @params options.request {function} 请求前的注入
 * @params options.response.success   请求返回成功的注入
 * @params options.response.fail      请求失败的注入
 */


function setInterceptors(ctx, options) {
  var globalRequestInterceptors = axios.interceptors.request.handlers;
  var globalResponseInterceptors = axios.interceptors.response.handlers;

  if (!ctx) {
    console.error('@kso/axios 注入第一个参数必填');
    return;
  }

  if (ctx.constructor !== axios.constructor && !(ctx instanceof Axios)) {
    console.error('@kso/axios 注入第一个参数必须是axios的工厂函数');
    return;
  }

  if (!isPlainObject(options)) {
    console.info('@kso/axios 传入的第二个参数必须是一个对象');
    return;
  }

  var _ref = options || {},
      request = _ref.request,
      response = _ref.response,
      name = _ref.name;

  if (request) {
    if (ctx.interceptors.request.accordanceWithGlobal && globalRequestInterceptors.find(function (_ref2) {
      var fulfilled = _ref2.fulfilled;
      return fulfilled === request;
    })) {
      console.warn('全局的请求中存在相同的拦截, 跳过这个拦截');
    } else {
      ctx.interceptors.request.unshiftUse(request, null, name);
    }
  }

  if (response) {
    var success = response.success,
        fail = response.fail;

    success = typeof success === 'function' && success || function (r) {
      return r;
    };

    fail = typeof fail === 'function' && fail || function (err) {
      return Promise.reject(err);
    };

    if (ctx.interceptors.response.accordanceWithGlobal) {
      var associated = globalResponseInterceptors.find(function (_ref3) {
        var fulfilled = _ref3.fulfilled,
            rejected = _ref3.rejected;
        return fulfilled === success || rejected == fail;
      });

      if (associated) {
        console.warn('全局的响应中存在相同的拦截, 跳过这个拦截');
      } else {
        ctx.interceptors.response.use(success, fail, name);
      }
    } else {
      ctx.interceptors.response.use(success, fail, name);
    }
  }
}
function parseDestHost(config) {
  var baseURL = config.baseURL,
      url = config.url; //链接使用了相对协议URL

  baseURL = relativeProtocol(baseURL);
  url = relativeProtocol(url); //保证baseURL有一个默认值

  if (!baseURL) {
    if (isServerRendering) {
      baseURL = 'https://drive.wps.cn';
    } else {
      var _window$location = window.location,
          protocol = _window$location.protocol,
          host = _window$location.host;
      baseURL = "".concat(protocol, "/").concat(host);
    }
  } //解析URL


  return new URL(url, baseURL);
} // 获取url参数对象，可服务端运行

function getQuery(url) {
  var query = {};

  if (url.indexOf('?') !== -1) {
    var str = url.substr(1);
    var pairs = str.split('&');

    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[pair[0]] = pair[1];
    }
  }

  return query; // 返回对象
}

export { getQuery, parseDestHost, setInterceptors };
